import React from 'react'
import { Tooltip, Row, Col } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { useShop } from '../../contexts/Shop'
import { Editor } from './../../components/Editor'

import {
  FormGroup,
  FormGroupTitleMenu,
  FormGroupTitle,
  FormGroupContent,
  FormGroupSeparator,
  FieldGroup
} from '../../components/FormGroup'
import { Uploader } from '../../components/Uploader'
import { SwitchToggle } from '../../components/SwitchToggle'
import { FaSun } from '../../components/Icon'

const LandingSidebarControl: React.FC = () => {
  const {
    merchantGet,
    merchantImageGet,
    merchantOnChange,
    merchantImageOnChange,
    merchantImagesLoadMap
  } = useShop()

  return (
    <>
      <FormGroup>
        <FormGroupTitleMenu>
          <FormGroupTitle>
            <Row align='middle' className='_mb-0' gutter={8}>
              <Col>Upload Logo</Col>
              <Col>
                <Tooltip
                  placement='right'
                  title={
                    <>
                      <strong>What will the logo be used for?</strong>
                      <br />
                      <br />
                      <div>
                        The logo will be used for consistent branding throughout
                        your Slerp customer experience. Learn how to format your
                        images{' '}
                        <a
                          className='_link-white _underline'
                          target='_blank'
                          rel='noopener noreferrer'
                          href='https://support.slerp.com/knowledge/uploading-images'
                        >
                          here
                        </a>
                        .
                      </div>
                    </>
                  }
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </Col>
            </Row>
          </FormGroupTitle>
        </FormGroupTitleMenu>

        <FormGroupContent>
          <FieldGroup>
            <Uploader
              file={merchantImageGet('avatar')}
              onFileSelect={merchantImageOnChange('avatar')}
              isUploading={merchantImagesLoadMap.avatar}
              icon={<FaSun />}
            />
          </FieldGroup>
        </FormGroupContent>
      </FormGroup>

      <FormGroup>
        <FormGroupTitleMenu>
          <FormGroupTitle>
            <Row align='middle' className='_mb-0' gutter={8}>
              <Col>Upload Splash image</Col>
              <Col>
                <Tooltip
                  placement='right'
                  title={
                    <>
                      <strong>Where is the splash image?</strong>
                      <br />
                      <br />
                      <div>
                        The splash image is displayed on the right side of your
                        landing page. Learn how to format your images{' '}
                        <a
                          className='_link-white _underline'
                          target='_blank'
                          rel='noopener noreferrer'
                          href='https://support.slerp.com/knowledge/uploading-images'
                        >
                          here
                        </a>
                        .
                      </div>
                    </>
                  }
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </Col>
            </Row>
          </FormGroupTitle>
        </FormGroupTitleMenu>

        <FormGroupContent>
          <FieldGroup>
            <Uploader
              file={merchantImageGet('header_image')}
              onFileSelect={merchantImageOnChange('header_image')}
              isUploading={merchantImagesLoadMap.header_image}
            />
          </FieldGroup>
        </FormGroupContent>
      </FormGroup>

      <FormGroupSeparator />

      <FormGroup>
        <FormGroupTitleMenu>
          <FormGroupTitle tooltipHeading='' tooltipBody=''>
            <Row align='middle' className='_mb-0' gutter={8}>
              <Col>Welcome message</Col>
              <Col>
                <Tooltip
                  placement='right'
                  title={
                    <>
                      <strong>What is a welcome message?</strong>
                      <br />
                      <br />
                      This is a heading used to welcome your customers to your
                      online Slerp store.
                    </>
                  }
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </Col>
            </Row>
          </FormGroupTitle>
        </FormGroupTitleMenu>

        <FormGroupContent>
          <FieldGroup>
            <Editor keyName={'welcome_message'} />
          </FieldGroup>
        </FormGroupContent>
      </FormGroup>

      <FormGroupSeparator />

      <FormGroup isCollapsible={false}>
        <FormGroupTitleMenu>
          <FormGroupTitle>
            <Row align='middle' className='_mb-0' gutter={8}>
              <Col>Pick-up address field</Col>
              <Col>
                <Tooltip
                  placement='right'
                  title={
                    <>
                      <strong>What is this for?</strong>
                      <br />
                      <br />
                      Enabling this will suggest the closest store to the
                      customer.
                    </>
                  }
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </Col>
            </Row>
          </FormGroupTitle>

          <SwitchToggle
            checked={merchantGet('pickup_address_enabled')}
            onChange={merchantOnChange('pickup_address_enabled')}
          />
        </FormGroupTitleMenu>
      </FormGroup>

      <br />
    </>
  )
}

export { LandingSidebarControl }
